import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function TraumatologoElEjido() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 to-teal-800 text-white py-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <nav className="text-sm mb-6">
            <ol className="flex items-center space-x-2 text-teal-100">
              <li><a href="/" className="hover:text-white transition-colors cursor-pointer">Inicio</a></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li><a href="/zonas-servicio" className="hover:text-white transition-colors cursor-pointer">Zonas de Servicio</a></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-white font-semibold">El Ejido</li>
            </ol>
          </nav>

          <div className="max-w-4xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Traumatólogo Veterinario</strong> en El Ejido
            </h1>
            <p className="text-xl md:text-2xl text-teal-50 mb-8 leading-relaxed">
              Especialista en <strong>cirugía TPLO, fracturas y traumatología veterinaria</strong> en El Ejido, Almería. Servicio móvil con más de 25 años de experiencia en tu clínica.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/#contacto"
                className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-check-line text-xl"></i>
                <span>Solicitar Valoración en El Ejido</span>
              </a>
              <a
                href="tel:+34600581975"
                className="inline-flex items-center justify-center space-x-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>Llamar: 600 581 975</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                <strong>Cirugía TPLO y Traumatología</strong> en El Ejido
              </h2>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                Como <strong>traumatólogo veterinario especializado en El Ejido</strong>, ofrezco cirugía ortopédica avanzada directamente en tu clínica veterinaria, incluyendo el <strong>Centro Veterinario Nuevo Poniente</strong> y otros centros de la zona.
              </p>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                Mi especialización en <strong>cirugía TPLO (Osteotomía de Nivelación de la Meseta Tibial)</strong> me ha permitido tratar con éxito cientos de casos de rotura de ligamento cruzado en perros de todas las razas y tamaños en El Ejido y comarca.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                El servicio móvil en <strong>El Ejido</strong> incluye todo el equipamiento quirúrgico de última generación, instrumental específico para TPLO y materiales de osteosíntesis de máxima calidad.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/6931a7affcbb0bb89c7080e7c0fd7919.jpg"
                alt="Traumatólogo veterinario El Ejido realizando cirugía TPLO en Centro Veterinario Nuevo Poniente"
                title="Cirugía TPLO El Ejido - Traumatología Veterinaria Especializada"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Case Study Highlight */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-8 md:p-12">
            <div className="flex items-start space-x-6">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                  <strong>Caso Clínico Destacado:</strong> TPLO en "Trasto" - El Ejido
                </h2>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  Cirugía TPLO exitosa realizada en el <strong>Centro Veterinario Nuevo Poniente de El Ejido</strong> para un canino de 5 años con rotura completa del ligamento cruzado craneal. Recuperación funcional completa en 8 semanas.
                </p>
                <a
                  href="/casos-clinicos/tplo-trasto-el-ejido"
                  className="inline-flex items-center space-x-2 bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <span>Ver Caso Completo</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Servicios de Traumatología</strong> en El Ejido
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Cirugía ortopédica especializada en tu clínica veterinaria de El Ejido
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Cirugía TPLO El Ejido</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Técnica de referencia para rotura de ligamento cruzado. Osteotomía de precisión con instrumental específico y placas bloqueadas de última generación.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Planificación radiográfica digital</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Casos documentados en El Ejido</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Recuperación funcional completa</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-bone-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Fracturas Complejas</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Osteosíntesis avanzada con placas, clavos intramedulares y fijadores externos para fracturas de fémur, tibia, húmero y pelvis.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Fracturas articulares</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Fijación mínimamente invasiva</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Materiales de última generación</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-wheelchair-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Luxaciones y Displasias</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Tratamiento quirúrgico de luxaciones de rótula, cadera y codo. Cirugías correctivas para displasia de cadera.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Luxación de rótula grados III-IV</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Prótesis de cadera (FHO)</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Triple osteotomía pélvica</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-brain-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Neurocirugía</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Cirugía de columna vertebral para hernias discales, compresiones medulares y fracturas vertebrales.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Hemilaminectomía dorsal</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Fenestración discal</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Estabilización vertebral</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-scissors-cut-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Artroscopias</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Cirugía mínimamente invasiva para diagnóstico y tratamiento de patologías articulares.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Fragmentación proceso coronoides</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Osteocondritis disecante</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Lesiones meniscales</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-microscope-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Cirugía Oncológica</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Resección de tumores con márgenes oncológicos adecuados y cirugía reconstructiva.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Mastectomías radicales</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Resección de sarcomas</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-600 mr-2 mt-0.5"></i>
                  <span>Amputaciones oncológicas</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              ¿Por Qué Elegir un <strong>Especialista en Traumatología</strong> en El Ejido?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-award-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <strong>25 Años de Experiencia Exclusiva</strong>
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Más de dos décadas dedicadas exclusivamente a la <strong>cirugía ortopédica veterinaria</strong>. Cientos de cirugías TPLO realizadas con éxito en El Ejido y toda Almería.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-truck-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <strong>Servicio Móvil en El Ejido</strong>
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Me desplazo a tu <strong>clínica veterinaria en El Ejido</strong> con todo el equipamiento. Tu paciente opera en un entorno conocido, reduciendo el estrés.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <strong>Equipamiento de Última Generación</strong>
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Instrumental quirúrgico específico para TPLO, placas bloqueadas de titanio y sistemas de fijación avanzados.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-text-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    <strong>Casos Documentados</strong>
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Casos clínicos reales documentados en El Ejido, como el éxito en TPLO de "Trasto" en el Centro Veterinario Nuevo Poniente.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Tu Clínica Está en El Ejido?
          </h2>
          <p className="text-xl text-teal-100 mb-8 leading-relaxed">
            Contacta conmigo para evaluar el caso, obtener una segunda opinión o programar la intervención quirúrgica en tu clínica veterinaria de El Ejido.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/#contacto"
              className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración Urgente (24h)</span>
            </a>
            <a
              href="tel:+34600581975"
              className="inline-flex items-center justify-center space-x-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Llamar: 600 581 975</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
